import RangeManager from './components/RangeManager';

export default RangeManager;
